<template>
  <section class="homelab-appointments-table">

    <div class="evollu-form py-3" v-if="showFilters">

      <div class="row">
        <!-- Created At Time Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('homelab.tables.created_at') }}</label>
          <range-date-picker
            id="created-at-date-picker"
            v-model="filters.createdAtDateRange"
            placeholder="---"
          >
          </range-date-picker>
        </div>

        <!-- Status Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('homelab.tables.status') }}:</label>
          <multiselect
            v-model="filters.status"
            :options="statuses"
            track-by="id"
            :custom-label="value => $t(value.name)"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :allow-empty="true"
            :multiple="true"
            :close-on-select="false"
            :limit="3"
          >
            <template slot="clear">
              <span class="multiselect__clear" v-if="filters.status.length"
                    @mousedown.prevent.stop="filters.status = []"></span>
            </template>
          </multiselect>
        </div>

        <!-- Entities Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('homelab.tables.entity') }}:</label>
          <multiselect
            v-model="filters.entities"
            :options="entityOptions"
            track-by="uid"
            :customLabel="formatedEntityLabel"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :allow-empty="true"
            :multiple="true"
            :close-on-select="false"
            :limit="3"
          >
            <template slot="clear">
              <span class="multiselect__clear" v-if="filters.entities.length"
                    @mousedown.prevent.stop="filters.entities = []"></span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row">
        <!-- Selected Time Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('homelab.tables.selected_time') }}</label>
          <range-date-picker
            id="selected-time-date-picker"
            v-model="filters.selectedDateRange"
            placeholder="---"
          >
          </range-date-picker>
        </div>
         <!-- Scheduled Time Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('homelab.tables.scheduled_time') }}</label>
          <range-date-picker
            id="scheduled-time-date-picker"
            v-model="filters.scheduledDateRange"
            placeholder="---"
          >
          </range-date-picker>
        </div>

        <!-- Insurers Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('homelab.insurer') }}:</label>
          <multiselect
            v-model="filters.insurers"
            :options="insurers"
            track-by="id"
            label="name"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :allow-empty="true"
            :multiple="true"
            :close-on-select="false"
            :limit="3"
          >
            <template slot="clear">
              <span class="multiselect__clear" v-if="filters.insurers.length"
                    @mousedown.prevent.stop="filters.insurers = []"></span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row">
         <!-- Packages Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('homelab.package') }}:</label>
          <multiselect
            v-model="filters.packages"
            :options="packages"
            track-by="id"
            label="name"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :allow-empty="true"
            :multiple="true"
            :close-on-select="false"
            :limit="3"
          >
            <template slot="clear">
              <span class="multiselect__clear" v-if="filters.packages.length"
                    @mousedown.prevent.stop="filters.packages = []"></span>
            </template>
          </multiselect>
        </div>

        <!-- Entities Filter -->
        <div class="col-12 col-md-4">
          <label class="form-label">{{ $t('homelab.tables.entity_of_creation') }}:</label>
          <multiselect
            v-model="filters.entitiesOfCreation"
            :options="entityOptions"
            track-by="uid"
            :customLabel="formatedEntityLabel"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :allow-empty="true"
            :multiple="true"
            :close-on-select="false"
            :limit="3"
          >
            <template slot="clear">
              <span class="multiselect__clear" v-if="filters.entitiesOfCreation.length"
                    @mousedown.prevent.stop="filters.entitiesOfCreation = []"></span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <v-server-table
      :columns="columns"
      :options="tableOptions"
      @row-click="click => $emit('appointment-selected', click.row)"
      @filter="onFilterUpdate"
      id="homelab-appointments-table"
      ref="homelabAppointmentsTable"
      name="homelabAppointmentsTable"
    >
      <span slot="request_type" slot-scope="{row}">
        {{ getFormatedAppointmentType(row) }}
      </span>
      <span slot="entity" slot-scope="{row}">
        {{ row.entity.name }}
      </span>

      <span slot="facility" slot-scope="{row}">
        {{ getFormatedFacility(row.facility) }}
      </span>

      <span slot="selected_time" slot-scope="{row}">
        {{ getFormatedSelectedTime(row.selected_time) }}
      </span>

      <span slot="scheduled_time_start" slot-scope="{row}">
        {{ getFormatedScheduledTime(row.scheduled_time_start, row.scheduled_time_end) }}
      </span>

      <span slot="status" slot-scope="{row}">
        {{ row.status ? $t(getStatusById(row.status.id)) : "N/A" }}
      </span>

      <span slot="created_at" slot-scope="{row}">
        {{ row.created_at | localTime }}
      </span>

      <span slot="payment.payment_status_id" slot-scope="{row}">
        {{
          (row.payment && row.payment.payment_status_id != null) ? $t(`homelab.payment_statuses.${row.payment.payment_status_id}`) : 'N/A'
        }}
      </span>

      <span slot="tube_nr" slot-scope="{row}">
        {{
          getTubeNumber(row)
        }}
      </span>
    </v-server-table>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import TableQueryMixin from '@/mixins/TableQueryMixin'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import Multiselect from 'vue-multiselect'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import { TABLE_HOMELAB_APPOINTMENTS } from '@/local-storage/LocalStorageKeys'

export default {
  props: {
    querySearch: {
      type: String,
      required: false
    },
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [
    TableQueryMixin,
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  components: {
    Multiselect,
    RangeDatePicker
  },
  computed: {
    ...mapState('homelab', [
      'insurers',
      'packages'
    ]),
    ...mapGetters([
      'clusters',
    ]),
    homelabService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.homelab_server)
    },
    readableEntities: function () {
      let homelabReadableAppointmentPermissions = this.homelabService.user_permissions.filter(permission => permission.info_type === 100 && permission.access_type >= 1)
      if (homelabReadableAppointmentPermissions.length > 0) {
        if (homelabReadableAppointmentPermissions.some(permission => permission.entity_id === null)) {
          return [...this.homelabService.entities]
        } else {
          return this.homelabService.entities.filter(entity => homelabReadableAppointmentPermissions.some(permission => entity.id === permission.entity_id))
        }
      } else {
        return []
      }
    },
    entityOptions: function () {
      return this.createClustersAndEntitiesList(this.clusters, this.readableEntities)
    },
    activeFilters: function () {
      let count = 0
      if (this.filters.createdAtDateRange.start !== null) count++
      if (this.filters.selectedDateRange.start !== null) count++
      if (this.filters.scheduledDateRange.start !== null) count++
      if (this.filters.createdAtDateRange.start !== null) count++
      if (this.filters.entities.length > 0) count++
      if (this.filters.entitiesOfCreation.length > 0) count++
      if (this.filters.status.length > 0) count++
      if (this.filters.insurers.length > 0) count++
      if (this.filters.packages.length > 0) count++
      return count
    }
  },
  data: function () {
    return {
      statuses: [
        { 'id': 1, 'name': 'homelab.statuses.1' },
        { 'id': 2, 'name': 'homelab.statuses.2' },
        { 'id': 3, 'name': 'homelab.statuses.3' },
        { 'id': 4, 'name': 'homelab.statuses.4' },
        { 'id': 5, 'name': 'homelab.statuses.5' },
        { 'id': 6, 'name': 'homelab.statuses.6' },
        { 'id': 20, 'name': 'homelab.statuses.20' }
      ],
      showQueryResetIcon: false,
      showExtraFilters: false,
      filters: {
        createdAtDateRange: {
          start: null,
          end: null
        },
        selectedDateRange: {
          start: null,
          end: null
        },
        createdAtDateRange: {
          start: null,
          end: null
        },
        scheduledDateRange: {
          start: null,
          end: null
        },
        entities: [],
        entitiesOfCreation: [],
        status: [],
        insurers: [],
        packages: []
      },
      queryUrl: `${this.$store.state.homelab_server}/appointments`,
      columns: ['created_at', 'selected_time', 'scheduled_time_start', 'entity', 'facility', 'request_type', 'name', 'address.city', 'status', 'total_price', 'payment.payment_status_id', 'tube_nr'],
      tableOptions: {
        filterable: true,
        sortable: ['created_at', 'selected_time', 'scheduled_time_start', 'status', 'name', 'address.city', 'health_number'],
        headings: {
          created_at: this.$t('homelab.tables.created_at'),
          selected_time: this.$t('homelab.tables.selected_time'),
          scheduled_time_start: this.$t('homelab.tables.scheduled_time'),
          request_type: this.$t('homelab.tables.request_type'),
          status: this.$t('homelab.tables.status'),
          name: this.$t('homelab.tables.name'),
          entity: this.$t('homelab.tables.entity'),
          facility: this.$t('homelab.tables.facility'),
          'address.city': this.$t('homelab.tables.city'),
          total_price: this.$t('homelab.labels.total_price'),
          'payment.payment_status_id': this.$t('homelab.tables.payment_status'),
          tube_nr: this.$t('homelab.tables.tube_nr')
        },
        customFilters: ['entities', 'createdAtDateStart', 'createdAtDateEnd', 'selectedDateStart', 'selectedDateEnd', 'scheduledDateStart', 'scheduledDateEnd', 'status', 'insurers', 'packages', 'entitiesOfCreation'],
        columnsClasses: {
          created_at: 'created_at',
          selected_time: 'selected_time',
          scheduled_time_start: 'scheduled_time_start',
          entity: 'entity',
          facility: 'facility',
          request_type: 'request_type',
          status: 'status',
          name: 'name',
          health_number: 'health_number',
          'address.city': 'address_city',
          'payment.payment_status_id': 'payment-status'
        },
        orderBy: {
          ascending: false,
          column: 'created_at'
        }
      },
    }
  },
  mounted: function () {
    this.$refs.homelabAppointmentsTable.toggleColumn('entity')
  },
  methods: {
    refresh: function () {
      this.$refs.homelabAppointmentsTable.refresh()
    },
    getStatusById: function (id) {
      let status = this.statuses.find(status => status.id === id)
      return status ? status.name : ''
    },
    getFormatedSelectedTime: function (date) {
      date = this.moment(this.$options.filters.localTime(date))
      return `${date.format('YYYY-MM-DD')} ${this.$t('date_helpers.hour_to')} ${date.format('HH:mm')}`
    },
    getTubeNumber: function (row) {
      if (!row.prescriptions || row.prescriptions.length === 0) {
        return 'N/A'
      }
      let tubeNumber = ''
      for (let em of row.prescriptions) {
        if (em.tube_nr !== "" && em.tube_nr !== null) {
          tubeNumber = tubeNumber.concat(em.tube_nr + ' / ')
        }
      }
      tubeNumber = tubeNumber.slice(0, -3)
      return tubeNumber !== '' ? tubeNumber : "N/A"
    },
    getFormatedScheduledTime: function (start, end) {
      if (start && end) {
        start = this.moment(this.$options.filters.localTime(start))
        end = this.moment(this.$options.filters.localTime(end))
        return `${start.format('YYYY-MM-DD')} ${this.$t('date_helpers.hour_from')} ${start.format('HH:mm')} ${this.$t('date_helpers.hour_to')} ${end.format('HH:mm')}`
      } else {
        return this.$t('homelab.unassigned')
      }
    },
    getFormatedFacility: function (facility) {
      if (facility) {
        if (facility.address && facility.address.city) {
          return `${facility.name} (${facility.address.city})`
        } else {
          return facility.name
        }
      } else {
        return this.$t('homelab.unassigned')
      }
    },
    getFormatedAppointmentType: function (appointment) {
      if (appointment.packages.length > 0) {
        let packages = []
        let charCounter = 0
        let hasMorePackages = false

        for (let i = 0; i < appointment.packages.length; i++) {
          if (charCounter + appointment.packages[i].name.length <= 50) {
            packages.push(appointment.packages[i].name)
          } else {
            hasMorePackages = i < appointment.packages.length
            i = appointment.packages.length
          }
        }

        let formatedAppointmentType = packages.join('; ')

        if (hasMorePackages) {
          formatedAppointmentType = `${formatedAppointmentType} (...)`
        }

        return formatedAppointmentType
      } else if (appointment.insurer) {
        if (appointment.insurer.id === 1) {
          return appointment.insurer.short_name
        } else {
          return `${this.$t('homelab.insurer')} - ${appointment.insurer.short_name}`
        }
      }
    },
    loadQueriesAndFilters: function () {
      return new Promise((resolve, reject) => {
        let filters = {
           createdAtDateRange: {
            start: null,
            end: null
          },
          selectedDateRange: {
            start: null,
            end: null
          },
          createdAtDateRange: {
            start: null,
            end: null
          },
          scheduledDateRange: {
            start: null,
            end: null
          },
          entities: [],
          entitiesOfCreation: [],
          status: [],
          insurers: [],
          packages: []
        }

        const state = LocalStorageHelper.get(TABLE_HOMELAB_APPOINTMENTS)

        if (state) {
          if (state.customQueries.createdAtDateStart && state.customQueries.createdAtDateStart !== '' && state.customQueries.createdAtDateEnd && state.customQueries.createdAtDateEnd !== '') {
            filters.createdAtDateRange.start = state.customQueries.createdAtDateStart
            filters.createdAtDateRange.end = state.customQueries.createdAtDateEnd
          }

          if (state.customQueries.selectedDateStart && state.customQueries.selectedDateStart !== '' && state.customQueries.selectedDateEnd && state.customQueries.selectedDateEnd !== '') {
            filters.selectedDateRange.start = state.customQueries.selectedDateStart
            filters.selectedDateRange.end = state.customQueries.selectedDateEnd
          }

          if (state.customQueries.createdAtDateStart && state.customQueries.createdAtDateStart !== '' && state.customQueries.createdAtDateEnd && state.customQueries.createdAtDateEnd !== '') {
            filters.createdAtDateRange.start = state.customQueries.createdAtDateStart
            filters.createdAtDateRange.end = state.customQueries.createdAtDateEnd
          }

          if (state.customQueries.scheduledDateStart && state.customQueries.scheduledDateStart !== '' && state.customQueries.scheduledDateEnd && state.customQueries.scheduledDateEnd !== '') {
            filters.scheduledDateRange.start = state.customQueries.scheduledDateStart
            filters.scheduledDateRange.end = state.customQueries.scheduledDateEnd
          }

          if (Array.isArray(state.selectedEntityUids) && state.selectedEntityUids) {
            filters.entities = this.reloadSelectedClustersAndEntities(this.entityOptions, state.selectedEntityUids)
          }

          if (Array.isArray(state.selectedEntityOfCreationUids) && state.selectedEntityOfCreationUids) {
            filters.entitiesOfCreation = this.reloadSelectedClustersAndEntities(this.entityOptions, state.selectedEntityOfCreationUids)
          }

          if (state.customQueries.status && state.customQueries.status !== '') {
            let statusIds = state.customQueries.status.split(',').map(id => parseInt(id))
            filters.status = this.statuses.filter(status => statusIds.some(id => status.id === id))
          }

          if (Array.isArray(this.insurers) && state.customQueries.insurers && state.customQueries.insurers !== '') {
            let insurerIds = state.customQueries.insurers.split(',').map(id => parseInt(id))
            filters.insurers = this.insurers.filter(insurer => insurerIds.some(id => insurer.id === id))
          }

          if (Array.isArray(this.packages) && state.customQueries.packages && state.customQueries.packages !== '') {
            let packageIds = state.customQueries.packages.split(',').map(id => parseInt(id))
            filters.packages = this.packages.filter(pack => packageIds.some(id => pack.id === id))
          }
        }
        this.filters = filters
      })
    },
    getActiveFilters: function () {
      return {
        query: this.$refs.homelabAppointmentsTable.query,
        orderBy: this.$refs.homelabAppointmentsTable.orderBy.column || '',
        ascending: this.$refs.homelabAppointmentsTable.orderBy.ascending || '',
        ...this.$refs.homelabAppointmentsTable.customQueries
      }
    },
    getTableReference: function () {
      return this.$refs.homelabAppointmentsTable
    }
  },
  watch: {
    'filters.selectedDateRange': function (value) {
      this.$refs.homelabAppointmentsTable.customQueries.selectedDateStart = value.start || ''
      this.emitTableFilter('vue-tables.homelabAppointmentsTable.filter::selectedDateEnd', value.end || '')
    },
    'filters.createdAtDateRange': function (value) {
      this.$refs.homelabAppointmentsTable.customQueries.createdAtDateStart = value.start || ''
      this.emitTableFilter('vue-tables.homelabAppointmentsTable.filter::createdAtDateEnd', value.end || '')
    },
    'filters.scheduledDateRange': function (value) {
      this.$refs.homelabAppointmentsTable.customQueries.scheduledDateStart = value.start || ''
      this.emitTableFilter('vue-tables.homelabAppointmentsTable.filter::scheduledDateEnd', value.end || '')
    },
    'filters.entities': function (options) {
      const selectedOptions = this.getSelectedOptionsIdsAndUids(options)
      this.emitTableFilter('vue-tables.homelabAppointmentsTable.filter::entities', Array.from(selectedOptions.ids).join(','))
      this.$nextTick(() => {
        let state = LocalStorageHelper.get(TABLE_HOMELAB_APPOINTMENTS)
        state.selectedEntityUids = Array.from(selectedOptions.uids)
        LocalStorageHelper.set(TABLE_HOMELAB_APPOINTMENTS, state)
      })
    },
    'filters.entitiesOfCreation': function (options) {
      const selectedOptions = this.getSelectedOptionsIdsAndUids(options)
      this.emitTableFilter('vue-tables.homelabAppointmentsTable.filter::entitiesOfCreation', Array.from(selectedOptions.ids).join(','))
      this.$nextTick(() => {
        let state = LocalStorageHelper.get(TABLE_HOMELAB_APPOINTMENTS)
        state.selectedEntityOfCreationUids = Array.from(selectedOptions.uids)
        LocalStorageHelper.set(TABLE_HOMELAB_APPOINTMENTS, state)
      })
    },
    'filters.status': function (value) {
      this.emitTableFilter('vue-tables.homelabAppointmentsTable.filter::status', value.map(v => v.id).join(','))
    },
    'filters.insurers': function (value) {
      this.emitTableFilter('vue-tables.homelabAppointmentsTable.filter::insurers', value.map(v => v.id).join(','))
    },
    'filters.packages': function (value) {
      this.emitTableFilter('vue-tables.homelabAppointmentsTable.filter::packages', value.map(v => v.id).join(','))
    },
    querySearch: function (search) {
      this.getTableReference().setFilter(search)
    },
    activeFilters: function (nrFilters) {
      this.$emit('filters-updated', nrFilters)
    },
    insurers: {
      handler: function () {
        if (this.insurers != null && this.packages != null) {
          this.loadQueriesAndFilters()
        }
      },
      immediate: true
    },
    packages: {
      handler: function () {
        if (this.insurers != null && this.packages != null) {
          this.loadQueriesAndFilters()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.payment-status {
  text-align: center !important;
}
</style>
